import { http } from "@/utils/http";

export const getChannelRaw = async key => {
  const channels = await http.request("get", "/rest/channels", {
    params: {
      query: JSON.stringify({
        key
      }),
      populate: JSON.stringify([])
    }
  });
  return channels;
};

export const getChannelList = data => {
  return http.request("get", "/rest/channels", { params: data });
};

/**
 * 获取渠道详情
 * @param {String} id 渠道ID
 * @param {Object} query 查询数据
 * @returns
 */
export const getChannelDetail = async (id, query = {}) => {
  return http.request("get", `/rest/channels/${id}`, {
    params: {
      ...query
    }
  });
};

/**
 * 获取选择器的渠道列表
 */
export const getChannelListAll = async () => {
  const res = await http.request("get", "/biz/channel/listAll", {
    params: {
      hierarchy: "byProductLine",
      removeActivated: true
    }
  });
  if (res && res.success) {
    return res.results;
  }
};

/**
 * 更新渠道的 AI 复制模板（三语言一次性保存）
 * @param {String} channelRef 渠道ID
 * @param {Object} templates 三语言模板 { zh, en, jp }
 */
export const updateChannelAiRateTemplate = async (channelRef, templates) => {
  return http.request("patch", `/biz/channel/updateAiRateTemplate`, {
    data: {
      channelRef,
      templates
    }
  });
};

/** MCP AccessKey 管理 */
export const listMcpAccessKeys = channelRef => {
  return http.request("post", "/biz/channel/openapi/listMcpAccessKeys", {
    data: { channelRef }
  });
};

export const createMcpAccessKey = (channelRef, expireAt) => {
  return http.request("post", "/biz/channel/openapi/createMcpAccessKey", {
    data: { channelRef, expireAt }
  });
};

export const removeMcpAccessKey = (channelRef, tokenRef) => {
  return http.request("post", "/biz/channel/openapi/removeMcpAccessKey", {
    data: { channelRef, tokenRef }
  });
};
